import { render, staticRenderFns } from "./successUrl.vue?vue&type=template&id=bf2dc0d8&"
import script from "./successUrl.vue?vue&type=script&lang=js&"
export * from "./successUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports